import styled from 'styled-components';


export const Container = styled.div`
  .MuiDialog-container {
    width: 100%;
  }
  .MuiDialog-scrollPaper {
    width: 100%;
  }
`;

export const ContainerHeader = styled.div`
    font-size: 1.4rem;
    font-weight: 600;
    width: 100%;
    height: 60px;
    padding: 20px;
    border-bottom: 1px solid #eee;
`;

export const ProfileForm = styled.div`
  display: flex;
  flex-direction; row;
  padding: 20px;
`;

export const ProfileFormPicture = styled.div`
  margin-right: 15px;
`;

export const ProfileFormName = styled.span`
  font-size: 1.2rem;
  font-weight: 600;
  margin-top: 18px;
`;

export const NewMaintenanceForm = styled.div`
  position: relative;
  min-height: 40%;
  width: 100%;
  background-color: #ffffff;
  border-radius: 8px;
`;

export const FormInputView = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding: 20px;
  border-bottom: 1px solid #eeee;
  transition: 1s linear;
`;

export const InputFilesLabel = styled.div`
  font-size: 1.2rem;
  text-align: center;
`;

export const InputView = styled.textarea`
  min-height: 120px;
  width: 100%;
  border: ${props => props.error? '1px solid red': 'none'};
  padding: 10px 20px 10px 20px;
  font-size: 1.3rem;
  background-color: #fff;
  border-radius: 8px;
  cursor: pointer;
`;

export const InputErrorLabel = styled.div`
  font-size: 0.8rem;
  color: red;
`;

export const InputIconGroup = styled.div`
  width: 75%;
  height: 60px;
  display: flex;
  flex-direction: row;
  margin-left: 20px;
`;

export const InputIcon = styled.div`
  display: flex;
  margin: 20px 5px 20px 5px;
  border: 2px solid #eee;
  padding: 5px 10px 5px 10px;
  transision: 2s;
  border-radius: 3px;
  box-shadow: 0.5px 0.5px 0px #999;
  cursor: pointer;
  &:hover {    
    box-shadow: 0.5px 0.5px 3px gray;
  }
`;

export const InputIconLabel = styled.span`
  color: #999;
  margin-left: 10px;
  font-size: 1rem;
`;
